/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  {
    value: "Fruits & Vegetables",
    label: "Fruits & Vegetables",
  },
  {
    value: "Bakery",
    label: "Bakery",
  },
  {
    value: "Meat & Seafood",
    label: "Meat & Seafood",
  },
  {
    value: "Dairy, Cheese & Eggs",
    label: "Dairy, Cheese & Eggs",
  },
  {
    value: "Rice, Grains & Beans",
    label: "Rice, Grains & Beans",
  },
  {
    value: "Oils, Spices etc.",
    label: "Oils, Spices etc.",
  },
  {
    value: "Drinks",
    label: "Drinks",
  },
  {
    value: "Other",
    label: "Other",
  },
];
